import Footer from "./Footer";
import Header from "./Header";

const Layout = (props: any) => {
    return (
        <div className="app-container">
            <Header />
            <div className="app-content">
                {props.children}
            </div>
            <Footer />
        </div>
    );
};

export default Layout;
